import { render, staticRenderFns } from "./QueryReinsurance.vue?vue&type=template&id=0e31ada0&"
import script from "./QueryReinsurance.vue?vue&type=script&lang=js&"
export * from "./QueryReinsurance.vue?vue&type=script&lang=js&"
import style0 from "./QueryReinsurance.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports